/**
 * Created by Victor Rojo on 26/8/19.
 */
import { Component, AfterViewInit, OnDestroy, ViewContainerRef, ViewChild,
          ComponentFactoryResolver, ApplicationRef, ComponentRef, Injector}     from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd }                     from '@angular/router';

import { IPlaceService }              from "../../iPlace/iPlace.service";
import { SectionService }             from "../section/Section.service";
import { Section }                    from "../section/Section";
import { AuthService }              from '../../shared/auth/auth.service';
import {TagService} from "../tag/Tag.service";
import {ItemTagType} from "../tag/Tag";
import {iPlaceDashboard} from "../../model/iPlace";


import { Subject }            from 'rxjs';
import { interval ,  Unsubscribable }             from "rxjs";
import {debounceTime}         from 'rxjs/operators';
import {distinctUntilChanged} from 'rxjs/operators';
import {map} from "highcharts/highcharts";
import {Globals} from "../../globals";
import {IPlaceSectionComponent} from "./IPlaceSection.component";

declare var maptalks: any;

@Component({
  templateUrl: './IPlaceFinder.component.html',
  styleUrls: ['./IPlaceFinder.component.css']
})
export class IPlaceFinderComponent implements OnDestroy, AfterViewInit{

  iPlaceList:any[];
  iPlaceMap:any;
  tagList:any[];
  tagMap:any = {};
  clusterLayer:any;
  search: string;
  collapse = false;
  private searchTerms = new Subject<string>();
  private searchText= '';
  iPlaceFilteredList:any[];

  sectionsMap:any = {};
  currentSectionId: string;
  selectedIPlace:string;
  markers:any[] = [];
  isLoading = true;
  showSearchMap = false;
  markerColor = "#e44235";
  isStation = false;

  private interval: Unsubscribable;
  private navigateOnInit : any = null;
  private iPlaceComponents: any = {};
  private lastiPlaceSection: any = {};

  @ViewChild("iplaceView", { read: ViewContainerRef, static: true }) iplaceView: ViewContainerRef;
  private activeiPlaceComponent: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private sectionService: SectionService,
    private iPlaceService: IPlaceService,
    private tagService: TagService,
    private globals: Globals,
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector
  ) {
    let data = localStorage.getItem("selected_iplace_" + this.authService.getUserID());
    if ( data ) {
      data = JSON.parse(data);
      if ( data.length == 2 ) {
        this.navigateOnInit = data;
      }
    }
    this.setMarkerColor();
    let p1 = this.tagService.get(ItemTagType.IPLACE);
    p1.then( tags => {
      this.tagList = tags;
      tags.forEach(tag => {
        this.tagMap[tag.id.tagKey] = tag;
      });
      let disableTags = localStorage.getItem("iplace_tag_filter_" + this.authService.getUserID());
      if ( disableTags ) {
        disableTags = JSON.parse(disableTags);
        this.tagList.forEach(tag => {
          if ( disableTags.indexOf(tag.id.tagKey) != -1 ) {
            tag.disabled = true;
          }
        });
      }
    });

    let p2 = this.iPlaceService.getDashboard();
    p2.then((dashboard:iPlaceDashboard) => {
      this.iPlaceList = dashboard.iPlaces.sort((a:any, b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.showSearchMap = this.iPlaceList && this.iPlaceList.length > 1;
    });

    Promise.all([p1,p2]).then( results => {
      this.sectionService.getAll().then( response => {
        Object.keys(response).forEach( iplaceId => {
          this.sectionsMap[iplaceId] = this.getSectionTree(response[iplaceId]);
        });
        if ( this.iPlaceList.length == 1 && !this.navigateOnInit ) {
          this.loadHomeSection(this.iPlaceList[0].idiPlace);
        }
      });
      let dashboard = results[1];
      this.filterIPlaceList();
      if ( this.showSearchMap ) {
        this.addMap(dashboard.zoom, dashboard.centerLatitude, dashboard.centerLongitude);
        this.updateLayer(this.iPlaceList);
        this.filterIPlaceMap();
      }

      this.isLoading = false;
    });

    this.router.events
      .subscribe((event) => {
        if ( event instanceof NavigationEnd && event.url == "/cloud/iplaces"){
          this.selectedIPlace = null;
          this.currentSectionId = null;
        }
      });

    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((result:string) => {
        this.searchText = result.toUpperCase();
        this.filterIPlaceList();
        this.filterIPlaceMap();
      });

    this.interval = interval(60000)
      .subscribe(() => {
        this.iPlaceService.getDashboard().then((dashboard:iPlaceDashboard) => {
          let news = dashboard.iPlaces.filter((iplace:any) => !this.iPlaceList.some(i => i.idiPlace == iplace.idiPlace));
          let iPlaceMap = this.iPlaceList.reduce((result,item) => {
            result[item.idiPlace] = item;
            return result;
          }, {});
          this.iPlaceList = dashboard.iPlaces.sort((a:any,b:any) => a.iPlaceName.localeCompare(b.iPlaceName))
            .map(iplace => {
              if ( iPlaceMap[iplace.idiPlace] ) {
                Object.keys(iplace).forEach(function (field) {
                  iPlaceMap[iplace.idiPlace][field] = iplace[field];
                });
                return iPlaceMap[iplace.idiPlace];
              } else {
                return iplace;
              }
            });
          this.filterIPlaceList();
          if ( this.showSearchMap ) {
            this.updateLayer(this.iPlaceList);
            this.filterIPlaceMap();
          }
        });
      });

    if ( globals.tenant == "ecomanager" || globals.tenant == "q8" || globals.tenant == "demoipetrol") {
        this.isStation = true;
    }
  }

  ngAfterViewInit(){
    if ( this.navigateOnInit ) {
      this.navigateToSection(this.navigateOnInit[0], this.navigateOnInit[1]);
    }
  }

  private setMarkerColor(){
    switch (this.globals.tenant){
      case "":
        this.markerColor = "#01163A";
        break;
      case "demoipetrol":
        this.markerColor = "#FC8718";
        break;
      case "galp":
        this.markerColor = "#FC8718";
        break;
      case "ecuador":
        this.markerColor = "#436DA4";
        break;
      case "q8":
        this.markerColor = "#1d2379";
        break;
      case "ask":
        this.markerColor = "#1a472b";
        break;
      case "ecomanager":
        this.markerColor = "#0a1836";
        break;
      case "hiotera":
        this.markerColor = "#2C9400";
        break;
      case "nacexa":
        this.markerColor = "#0B4691";
        break;
      case "freeenergia":
        this.markerColor = "#db0584";
        break;
      case "kontrolwat":
        this.markerColor = "#789287";
        break;
      case "respira":
        this.markerColor = "#14472c";
        break;
      case "iotino":
        this.markerColor = "#911f81";
        break;
      case "depourense":
        this.markerColor = "#00558C";
        break;
      case "h2h":
        this.markerColor = "#768822";
        break;
      case "hacsuite":
        this.markerColor = "#9CC55D";
        break;
      case "smartpadel":
        this.markerColor = "#01163A";
        break;
    }
  }

  private addMap(zoom, latitude, longitude){
    if ( !maptalks.iplace ) {
      maptalks.iplace = {}
    }
    var self = this;
    maptalks.iplace.loadHomeSection =function(e){
      self.loadHomeSection(e);
    };

    var iPlaceMap = new maptalks.Map("iPlaceMap",{
      center:   [longitude,latitude],
      zoom   :  zoom,
      centerCross : false,
      zoomControl: {
        'position'  : 'bottom-right',
        'slider'    : false,
        'zoomLevel' : false
      },
      baseLayer : new maptalks.TileLayer('tile',{
        urlTemplate: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
        subdomains: ['a','b','c','d'],
        attribution: false
      })
    });
    iPlaceMap.setMinZoom(zoom);
    this.iPlaceMap = iPlaceMap;
    this.iPlaceMap.on('click', function (e) {
      iPlaceMap.identify(
        {
          'coordinate' : e.coordinate,
          'layers' : [self.clusterLayer]
        },
        function (geos) {
          if (geos.length === 0) {
            return;
          }
          let extent;
          geos.forEach(function (g) {
            if ( g.children && g.children.length > 0) {
              g.children.forEach(function (r:any) {
                if ( !extent ) {
                  extent = new maptalks.Extent(r.getExtent())
                } else {
                  extent = extent.combine(r.getExtent());
                }
              });
            }

            console.log(g);
          });
          if ( extent ) {
            iPlaceMap.setCenterAndZoom(e.coordinate, iPlaceMap.getZoom() + 2);
          }
        }
      );
    });


  }

  private updateLayer(iPlaceList:any[]){
    if ( this.clusterLayer ) {
      this.iPlaceMap.removeLayer(this.clusterLayer);
      this.markers.splice(0,this.markers.length);
    }
    var clusterLayer = new maptalks.ClusterLayer('cluster', [], {
      'noClusterWithOneMarker' : true,
      'maxClusterZoom' : 8,
      'maxClusterRadius' : 160,
      //"count" is an internal variable: marker count in the cluster.
      'symbol': {
        'markerType' : 'ellipse',
        'markerFill' : { property:'count', type:'interval', stops: [[0, 'rgb(135, 196, 240)'], [9, '#1bbc9b'], [99, 'rgb(216, 115, 149)']] },
        'markerFillOpacity' : 0.7,
        'markerLineOpacity' : 1,
        'markerLineWidth' : 3,
        'markerLineColor' : '#fff',
        'markerWidth' : { property:'count', type:'interval', stops: [[0, 40], [9, 60], [99, 80]] },
        'markerHeight' : { property:'count', type:'interval', stops: [[0, 40], [9, 60], [99, 80]] }
      },
      'drawClusterText': true,
      'geometryEvents' : true,
      'single': true
    });
    this.clusterLayer = clusterLayer;
    this.iPlaceMap.addLayer(this.clusterLayer);
    this.addToMap(iPlaceList);
  }

  private getSectionTree(sections:Section[]) {
    let sectionsMap = sections.reduce(function(map, section) {
      map[section.sectionId] = section;
      section['children'] = [];
      section['value'] = section.name;
      return map;
    }, {});

    sections.forEach(section => {
      if ( section.parentSectionId ) {
        let parent = sectionsMap[section.parentSectionId];
        if ( parent ) {
          parent.children.push(section);
        }
      }
    });
    sections.forEach((section:any) => {
      section.children = section.children.sort( (a:any,b:any) => a.name.localeCompare(b.name))
    });
    let homeSection = sections[0];
    return homeSection;
  }

  private addToMap(iPlaceList:any[]){
    iPlaceList.filter( iplace => iplace.longitude != null && iplace.latitude)
      .forEach((iPlace, i) => {
      var marker = new maptalks.Marker([iPlace.longitude, iPlace.latitude], {
        id: iPlace.idiPlace,
        'symbol' : [{
          'markerType': 'pin',
          'markerFill': this.markerColor,
          'markerFillOpacity': 1,
          'markerLineColor': '#34495e',
          'markerLineWidth': 1,
          'markerLineOpacity': 1,
          'markerLineDasharray':[],
          'markerWidth': 50,
          'markerHeight': 40,
          'markerDx': 0,
          'markerDy': 0,
          'markerOpacity' : 1
        },
          {
            'textFaceName' : 'sans-serif',
            'textName' : iPlace.iPlaceName,
            'textSize' : 12,
            'textHaloFill'      : '#fff',
            'textHaloRadius'    : 2,
            'textFill'          : '#34495e',
            'textHorizontalAlignment' : 'middle',
            'textVerticalAlignment'   : 'top',
            'textAlign'               : 'center',
            'textWrapCharacter' : '\n',
            'textLineSpacing'   : 0,
            'textDy'   : 18
          }
        ]
      });
      marker.addTo(this.clusterLayer);
      let content = '<div class="content">' +
        '<span class="card-title clickable font-color-primay2" onclick="maptalks.iplace.loadHomeSection(\'' + iPlace.idiPlace + '\');">' + iPlace.iPlaceName + '</span>'

      content += '<div class="">';
      if ( iPlace.tags ) {
        iPlace.tags.forEach(tag => {
          content += '<span class="label mb-10" style="background:' + this.tagMap[tag].colour + ';" >' + tag + '</span>';
        });
      }
      content += '</div>';
      content += '<div class="marker-arrow"></div>' +
        '</div>';

      marker.setInfoWindow({
        'custom' : true,
        'width'  : 180,
        'height' : 90,
        'content'   : content,
        'autoOpenOn' : 'click',
        'autoCloseOn' : 'click'
      });
      this.markers.push(marker);
    });
  }

  loadiPlaceSection(iPlaceId:string){
    let sectionId = this.lastiPlaceSection[iPlaceId];
    if ( sectionId ) {
      this.selectSection(sectionId, iPlaceId);
    } else {
      this.loadHomeSection(iPlaceId);
    }
  }

  loadHomeSection(iPlaceId:string){
    let section = this.sectionsMap[iPlaceId];
    this.selectSection(section.sectionId, iPlaceId);
  }

  onSectionSelected(section:any){
    if ( section ) {
      this.selectSection(section.sectionId, section.iPlaceId);
    } else {
      this.selectSection(null, null);
    }
  }

  selectSection(sectionId: any, iPlaceId:string): void {
    if ( sectionId == null ) {
      localStorage.removeItem("selected_iplace_" + this.authService.getUserID());
      this.navigateToSection(iPlaceId, null);
    } else {
      this.selectedIPlace = iPlaceId;
      if ( this.currentSectionId != sectionId) {
        this.navigateToSection(iPlaceId, sectionId);
      }
    }
    let data = [this.selectedIPlace, this.currentSectionId];
    localStorage.setItem("selected_iplace_" + this.authService.getUserID(), JSON.stringify(data));
  }

  private navigateToSection(iPlaceId, sectionId){
    this.currentSectionId = sectionId;
    this.selectedIPlace = iPlaceId;
    this.lastiPlaceSection[iPlaceId] = sectionId;

    if ( iPlaceId && sectionId) {
      let componentRef;
      if ( !this.iPlaceComponents[iPlaceId]) {
        componentRef = this.componentFactoryResolver
          .resolveComponentFactory(IPlaceSectionComponent)
          .create(this.injector);
        this.iPlaceComponents[iPlaceId] = componentRef;
      } else {
        componentRef = this.iPlaceComponents[iPlaceId];
      }

      if ( componentRef.instance.id == null || componentRef.instance.id.iPlaceId != iPlaceId || componentRef.instance.id.sectionId != sectionId ) {
        componentRef.instance.id = {
          iPlaceId: iPlaceId,
          sectionId: sectionId
        };
      }
      this.activeiPlaceComponent = componentRef;

      // Attach component to the appRef so that it's inside the ng component tree
      //this.appRef.attachView(componentRef.hostView);
      this.iplaceView.detach();
      this.iplaceView.insert(componentRef.hostView);
      componentRef.instance.setStreamingActive(true);
    } else {
      if ( this.activeiPlaceComponent ) {
        this.activeiPlaceComponent.instance.setStreamingActive(false);
        this.activeiPlaceComponent = null;
      }
      this.iplaceView.detach();
    }

    //this.router.navigate(["cloud/iplaces", iPlaceId, "section", sectionId]);
  }

  toogleTag(tag) {
    tag.disabled = !tag.disabled;
    this.storeTagFilter();
    this.filterIPlaceList();
    this.filterIPlaceMap();
  }
  toogleCollapse(){
    this.collapse = !this.collapse;
  }

  storeTagFilter(){
    var data = this.tagList
      .filter(tag =>  tag.disabled)
      .map( tag => tag.id.tagKey );

    localStorage.setItem("iplace_tag_filter_" + this.authService.getUserID(), JSON.stringify(data));
  }

  onSearch(term: string){
    this.searchTerms.next(term);
  }

  private filterIPlaceList(){
    let iplaces = [];
    if ( this.searchText ) {
      iplaces = this.iPlaceList.filter((iplace:any) => iplace.iPlaceName.toUpperCase().indexOf(this.searchText) >= 0);
    } else {
      iplaces = this.iPlaceList;
    }

    if ( this.tagList.length ) {
      iplaces = iplaces.filter(iplace => {
          let enabled = this.tagList
            .filter(tag => !tag.disabled );
          return !enabled.length || enabled.some(tag => iplace.tags != null && iplace.tags.indexOf(tag.id.tagKey) != -1 )
      }

      );
    }

    this.iPlaceFilteredList = iplaces;
  }

  private filterIPlaceMap(){
    var iPlaceIds = this.iPlaceFilteredList
      .map(iPlace => iPlace.idiPlace);
    this.markers.forEach(marker => {
      if ( iPlaceIds.indexOf(marker.getId()) != -1 ) {
        marker.show();
      } else {
        marker.hide();
      }
    });
  }

  selectAllTags(){
    this.tagList.forEach(tag =>  tag.disabled = false);
    this.storeTagFilter();
    this.filterIPlaceList();
    this.filterIPlaceMap();
  }

  unSelectAllTags(){
    this.tagList.forEach(tag =>  tag.disabled = true);
    this.storeTagFilter();
    this.filterIPlaceList();
    this.filterIPlaceMap();
  }

  public ngOnDestroy(): void {
    if ( this.interval ) {
      this.interval.unsubscribe()
    }
    this.navigateOnInit = null;
  }
}
